module.exports = __webpack_public_path__ + "static/media/event-friends-iphonex-event-details-1.90e08683.jpg";